<template>
  <div class="app-tariff-break">
    <div v-show="isReady">
      <SimonModal
        :is-visible="showBreakModal"
        id="tariff-break-modal-activate"
        show-footer-buttons
        @hide="showBreakModal = false"
        @btnLeft="showBreakModal = false"
        @btnRight="activateTariffBreak"
        btn-left-title="Verwerfen"
        btn-right-title="Übernehmen">
        <template v-slot:modalTitle>
            <h1><slot name="txtTarifBreakModalTitle"></slot></h1>
        </template>
        <slot name="txtTarifBreakModalInfo"></slot>
      </SimonModal>

      <SimonModal
        :is-visible="showBreakModalActive"
        id="tariff-break-modal-deactivate"
        show-footer-buttons
        @hide="showBreakModalActive = false"
        @btnLeft="showBreakModalActive = false"
        @btnRight="deactivateTariffBreak"
        :btn-left-title="getSlotText('txtTarifBreakModalCTACancel', 'Abbrechen')"
        :btn-right-title="getSlotText('txtTarifBreakModalCTASubmitActive','Pause aufheben')"
      >
        <template v-slot:modalTitle>
          <h4><slot name="txtTarifBreakModalTitleActive"></slot></h4>
        </template>
        <slot name="txtTarifBreakModalInfoActive"></slot>
      </SimonModal>
      <div>
        <div v-if="!this.contractPauseActive && !this.contractPauseCreated" class="tariff-break-content">
          <div class="tariff-break-txt">
            <h3><slot name="txtTarifBreakHeadline">Deinen Vertrag pausieren</slot></h3>
            <slot name="txtTarifBreakInfoTxt">Info</slot>
          </div>
          <button @click="showBreakModalClick" :disabled="this.contractTerminated || this.contractDismissedInFuture">
            <slot name="txtTarifBreakCTA">Vertrag pausieren</slot>
          </button>
        </div>
        <div v-if="this.contractPauseCreated" class="tariff-break-content">
          <div class="tariff-break-txt">
            <h3><slot name="txtTarifBreakHeadlineCreated">Dein Vertrag wird pausiert</slot></h3>
            <slot name="txtTarifBreakInfoTxtCreated">Info</slot>
          </div>
          <button @click="deactivateTariffBreak" :disabled="this.contractTerminated || this.contractDismissedInFuture">
            <slot name="txtTarifBreakCTACreated">Pause widerrufen</slot>
          </button>
        </div>
        <div v-if="this.contractPauseActive" class="tariff-break-content">
          <div class="tariff-break-txt">
            <h3><slot name="txtTarifBreakHeadlineActive">Dein Vertrag ist pausiert</slot></h3>
            <dyn-slot :slot-data="slotData"><slot name="txtTarifBreakInfoTxtActive">Info</slot></dyn-slot>
          </div>
          <button @click="showBreakModalActiveClick" :disabled="this.isContractDismisseld || this.hasPendingDismissal">
            <slot name="txtTarifBreakCTAActive">Pause aufheben</slot>
          </button>
        </div>
      </div>
    </div>
    <div v-if="showError && displayError" v-html="this.errorMsg" class="error-box"></div>
    <div v-if="gotBackendError" v-html="this.beErrorGetLastMessage()" class="error-box"></div>
  </div>
</template>

<script>
import beErrors from '@/mixins/beErrors'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import { mapActions } from 'vuex'
import transaction from '@/mixins/transaction'
import customerContractState from '@/mixins/customerContractState'
import SimonModal from '@/components/modal/SimonModal.vue'
import urlParam from '@/mixins/urlParam'

export default {
  name: 'TariffBreak',
  components: { SimonModal },
  data () {
    return {
      showBreakModal: false,
      showBreakModalActive: false,
      showError: false,
      displayError: false,
      gotBackendError: false,
      errorMsg: {
      },
      modalHash: null
    }
  },
  mixins: [
    beErrors,
    transaction('tariffBreak'),
    customerContractState(),
    dateFormatter,
    urlParam
  ],
  created () {
    document.addEventListener('openTariffBreak', this.showBreakModalClick)
  },
  computed: {
    isReady () {
      return this.loadedContractState
    },
    slotData () {
      return { endDate: this.dateFormatter(new Date(this.contractPauseEndDate)) }
    },
    deleteSuccessToastMsg () {
      if (this.contractPauseCreated) {
        return this.$slots.txtTarifWithdrawBreakToastSuccessMsg[0].text
      }
      if (this.contractPauseActive) {
        return this.$slots.txtTarifCancelBreakToastSuccessMsg[0].text
      }
      return ''
    }
  },
  methods: {
    ...mapActions('tariffBreak', [
      'bookContractPause',
      'deleteContractPause'
    ]),
    activateTariffBreak () {
      this.displayError = false
      this.showBreakModal = false

      if (this.showError) {
        this.displayError = true
        const data = {
          type: 'technical',
          message: this.errorMsg
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }

        return
      }

      this.bookContractPause({})
        .then((response) => {
          if (response?.success === true) {
            this.reQueryContractState()
            this.gotBackendError = false
            this.showError = false
            this.displayError = false
            this.errorMsg = ''
            this.successToast(this.$slots.txtTarifBreakToastSuccessMsg ? this.$slots.txtTarifBreakToastSuccessMsg[0].text : 'Dein Vertrag wurde erfolgreich pausiert.')
          }
        }).catch((e) => {
          this.gotBackendError = true
          const errMsg = this.beErrorGetLastMessage()
          if (errMsg !== null) {
            const data = {
              type: 'technical',
              message: errMsg.substring(0, 50),
              code: this.beErrorGetLastErrorCode()
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        })
    },
    deactivateTariffBreak () {
      this.displayError = false

      if (this.showError) {
        this.displayError = true
        const data = {
          type: 'technical',
          message: this.errorMsg
        }
        if (typeof window.trackingNS?.track?.tracking === 'function') {
          window.trackingNS.track.tracking('error', data)
        }

        return
      }

      this.deleteContractPause({})
        .then((response) => {
          if (response?.success === true) {
            this.reQueryContractState()
            this.gotBackendError = false
            this.showError = false
            this.displayError = false
            this.errorMsg = ''
            this.successToast(this.deleteSuccessToastMsg)
          }
        }).catch((e) => {
          this.gotBackendError = true
          const errMsg = this.beErrorGetLastMessage()
          if (errMsg !== null) {
            const data = {
              type: 'technical',
              message: errMsg.substring(0, 50),
              code: this.beErrorGetLastErrorCode()
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        })
    },
    showBreakModalClick () {
      if (!this.isContractDismisseld && !this.hasPendingDismissal) {
        this.showBreakModal = true
      }
    },
    showBreakModalActiveClick () {
      if (!this.isContractDismisseld && !this.hasPendingDismissal) {
        this.showBreakModalActive = true
      }
    },
    showModalBreakModalActiveDeepLink () {
      if (this.contractPauseActive) {
        this.showBreakModalActiveClick()
      } else {
        this.successToast(this.$slots.txtTarifBreakAlreadyCancelledToastSuccessMsg ? this.$slots.txtTarifBreakAlreadyCancelledToastSuccessMsg[0].text : 'Deine Vertragspause ist bereits aufgehoben. Sauber!')
      }
    }
  },
  mounted () {
    if (this.getURLParam('modal')) {
      this.modalHash = this.getURLParam('modal')
      history.replaceState(null, null, window.location.pathname)
    }
  },
  watch: {
    loadedContractState: {
      immediate: true,
      handler: function (newValue) {
        if (newValue) {
          if (this.modalHash && this.modalHash === 'tariff-break-modal-deactivate') {
            this.showModalBreakModalActiveDeepLink()
          }
        }
      }
    }
  }
}
</script>
